import { createContext } from 'react';
export const microfrontendContext = createContext({
    mfServer: '',
    mfId: '',
    context: {},
});
//# sourceMappingURL=context.js.map